import {Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table} from "reactstrap";
import React, {Component, Fragment} from "react";
import {setFormFieldValue} from "../Applications/shared/shared";
import {deleteData, getData, patchData, postData} from "../../api/doLogin";
import "react-select/dist/react-select.min.css"

export class CameraPermissionsUserPicker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      data: [],
      totalResults: 0,
      options: [],
      selected: [],
      formData: {},
      showIndicator: false,
      showDialog: true,
      showAdd: false,
      addChosen: ""
    }
  }

  componentDidMount() {
    this.getUserList();
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   // like writing return true
  //   return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  // }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['formData'], false, (data) => this.setState({formData: data}));
  }

  saveUserList() {
    let self = this;
    console.log({permissions: [...this.state.selected]});
    postData(`${this.props.type || "training"}/${this.props.selected}/users`, {permissions: [...this.state.selected]}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.props.onClose && self.props.onClose();
        } else {

        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  addUser() {
    let self = this;
    if (this.state.addChosen === "") return;
    postData(`camera/${this.props.selected}/users/${this.state.addChosen}`, {})
      .then((data) => {
        console.log(data.data);
        if (data.status === "Success") {
          self.setState({
            showAdd: false, addChosen: "", options: [
              ...this.state.options.map((user) => {
                if (String(user.id) !== data.data.user_id) return user;
                return {...user, permId: data.data.id, access: data.data.access}
              })
            ]
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  removeUser(id) {
    let self = this;
    deleteData(`camera/${this.props.selected}/users/${id}`, {})
      .then((data) => {
        console.log(data.data);
        if (data.status === "Success") {
          self.setState({
            showAdd: false, addChosen: "", options: [
              ...this.state.options.map((user) => {
                if (user.id !== id) return user;
                return {...user, permId: null, access: null}
              })
            ]
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  setAccess(id, access) {
    let self = this;
    patchData(`camera/${this.props.selected}/users/${id}/${access}`, {})
      .then((data) => {
        console.log(data.data);
        if (data.status === "Success") {
          self.setState({
            showAdd: false, addChosen: "", options: [
              ...this.state.options.map((user) => {
                if (user.id !== id) return user;
                return {...user, access: access}
              })
            ]
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getUserList() {
    let self = this;
    getData(`camera/${this.props.selected}/users`, {})
      .then((data) => {
        if (data.status === "Success") {
          console.log(data.data);
          self.setState({
            options: data.data.users.map((user) => {
              return {
                ...user,
                label: `${user.lname}, ${user.fname}`,
              }
            }).sort((userA, userB) => userA.label > userB.label ? 1 : -1)
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  hasReadOnlyPerms(permission) {
    if (permission[this.props.permissionType]) {
      return (permission[this.props.permissionType].length > 0 && permission[this.props.permissionType].indexOf(2) === -1);
    }
    return false;
  }

  render() {
    const validOptions = this.state.options.filter((option) =>
      (option.visible === 1 || this.state.selected.indexOf(option.value) > -1) && this.hasReadOnlyPerms(option.perms));
    const tdStyle = {padding: "unset", verticalAlign: "middle"};
    return (
      <React.Fragment>
        {this.state.options.length > 0 && (
          <Modal isOpen={true}
                 className={'modal-md ' + this.props.className}>
            <ModalHeader>Select Users{this.props.title ? ` - ${this.props.title}` : ""}</ModalHeader>
            <ModalBody>
              <Table>
                <thead>
                <tr>
                  <td style={tdStyle}>Name</td>
                  <td style={tdStyle}>Access</td>
                  <td style={tdStyle}>Action</td>
                </tr>
                </thead>
                <tbody>
                {this.state.options.filter((user) => !!user.permId).map((user, index) => {
                  return (<tr key={index}>
                    <td style={tdStyle}>{user.label}{user.visible === 0 ? " (deactivated)" : ""}</td>
                    <td style={tdStyle}><a style={{cursor: "pointer"}}
                                           onClick={(e) => {
                                             e.preventDefault();
                                             this.setAccess(user.id, user.access === 1 ? 0 : 1);
                                           }}>{user.access === 1 ? "Full Control" : "View Media"}</a></td>
                    <td style={tdStyle}><Button onClick={() => this.removeUser(user.id)}>Remove</Button></td>
                  </tr>)
                })}
                </tbody>
                <tfoot>
                <tr>
                  <td colSpan={3}>
                    {!this.state.showAdd ?
                      <Button onClick={() => this.setState({showAdd: true})}>Add</Button>
                      :
                      <Fragment>
                        <Row>
                          <Col xs={12} md={6}>
                            <Input type={"select"}
                                   defaultValue={""}
                                   onChange={(event) => {
                                     this.setState({addChosen: event.target.value});
                                   }}
                            >
                              <option value={""} disabled={true}>Select...</option>
                              {this.state.options.filter((user) => !user.permId && (user.visible === 1)).map((user, index) => {
                                return <option key={index} value={user.id}>{user.label}</option>
                              })}
                            </Input>
                          </Col>
                          <Col xs={12} md={6}>
                            <Button onClick={() => this.addUser()}>Add</Button>
                            <Button onClick={() => this.setState({showAdd: false, addChosen: ""})}>Cancel</Button>
                          </Col>
                        </Row>
                      </Fragment>
                    }
                  </td>
                </tr>
                </tfoot>
              </Table>
            </ModalBody>
            <ModalFooter>
              {/*<Button color="info"*/}
              {/*        onClick={() => this.saveUserList()}>Save</Button>*/}
              <Button color="secondary"
                      onClick={() => this.props.onClose()}>Close</Button>
            </ModalFooter>
          </Modal>
        )}

      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Camera/CameraPermissionsUserPicker.js